import styled, { css } from "styled-components/macro";

export const FormGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: flex-end;
  gap: 24px;

  .ant-form-item:nth-child(3) {
    min-width: max-content;
  }

  @media ${({ theme }) => theme.media.tablet} {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 0;

    .ant-form-item:nth-child(3) {
      min-width: 0;
    }
  }

  @media ${({ theme }) => theme.media.phone} {
    display: block;
  }
`;

export const AccommodationCardRoot = styled.button<{ $selected: boolean }>`
  padding: 16px;
  background: white;
  cursor: pointer;
  text-align: center;
  min-height: 132px;

  ${({ $selected }) =>
    $selected
      ? css`
          border: 2px solid ${({ theme }) => theme.colors.primary};
          background: ${({ theme }) => theme.colors.bgPrimary};
        `
      : css`
          border: 1px solid ${({ theme }) => theme.colors.borderSecondary};
        `}
  border-radius: 8px;
`;

export const AccommodationCardIconContainer = styled.div`
  height: 1.5rem;
  margin-bottom: 8px;

  svg {
    height: 100%;
  }
`;

export const AccommodationCardLabel = styled.p`
  font-size: ${({ theme }) => theme.font.size};
  color: ${({ theme }) => theme.colors.hardGray};
  font-weight: ${({ theme }) => theme.font.weightMedium};
  line-height: 1.5rem;
  margin-bottom: 8px;
`;

export const AccommodationCardDescription = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.midGrey};
  line-height: ${({ theme }) => theme.text.defaultLineHeight};
`;
